export default "__VITE_ASSET__x3HM8K9q__"